module.exports = __webpack_public_path__ + "ce665e8e480c64d9160f7185048193e9.svg";